export function formatCityState(city: string, state: string): string {
  if (city && city.length > 0 && state && state.length > 0) {
    return `${city}, ${state}`;
  } else if (city && city.length > 0) {
    return city;
  } else {
    return state;
  }
}
